import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { logHourFormatTime } from "../../../constants/date";
import BuildingIcon from "../../../icons/BuildingIcon";
import TagBlueIcon from "../../../icons/TagBlueIcon";
import RejectWhiteIcon from "../../../icons/RejectWhiteIcon";
import "./style.scss";

interface LogHourCardProps {
  main_category: {
    name: string;
    uuid: string;
  };
  sub_activity: {
    name: string;
    uuid: string;
  };
  hours: string;
  minutes: string;
  property_name?: string;
  activity: {
    name: string;
    uuid: string;
  };
  user: {
    image: string;
    name: string;
    role: string;
    role_label: string;
    uuid: string;
  };
  cpa_comment: any;
  status?: string;
  reason?: string;
}

const LogHourCard: React.FC<LogHourCardProps> = ({
  main_category,
  sub_activity,
  hours,
  minutes,
  property_name,
  activity,
  user,
  cpa_comment,
  status,
  reason,
}) => {
  return (
    <div className="mb-4">
      <div className="custom-card mx-auto">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span
              className={
                main_category?.name.toLowerCase() == "material participation"
                  ? "category-badge"
                  : "category-badge yellow"
              }
            >
              {main_category?.name}
            </span>
          </div>

          <div className="text-area d-flex justify-content-between align-items-center flex-wrap">
            <h5 className="mt-3 fw-bold">{sub_activity?.name}</h5>

            <div className="d-flex justify-content-end mt-2">
              <span className="time-badge">
                {logHourFormatTime({
                  hours: hours,
                  minutes: minutes,
                })}
              </span>
            </div>
          </div>

          <div className="mt-3 d-flex gap-2 justify-content-between align-items-center flex-wrap">
            <span className="tag tag-red text-left mb-1">
              <BuildingIcon /> &nbsp;
              {property_name}
            </span>

            <span className="tag tag-blue">
              <TagBlueIcon /> &nbsp;
              {activity?.name}
            </span>
          </div>
        </div>

        <div className="status-row d-flex justify-content-between align-items-center">
          <span className="status-badge">Logged By</span>
          <div className="d-flex align-items-center logged-by rejected-area">
            <img
              className="img-fluid"
              src={
                user?.image ? `${user?.image}` : "/assets/img/userCircle.png"
              }
              alt="peofile"
            />
            <div>
              <span className="owner-role">{user?.role_label}</span>
              <span className="fw-semibold d-block text-dark client-name">
                {user?.name}
              </span>
            </div>
          </div>

          {cpa_comment && (
            <span className="status-badge-2 commented">Commented</span>
          )}

          {status?.toLowerCase() == "reject" && (
            <>
              <span className="status-badge-2 rejected">Rejected</span>

              {reason && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="alert-tooltip" className="white-tooltip">
                      {reason}
                    </Tooltip>
                  }
                >
                  <div className="alert-icon" role="button">
                    <RejectWhiteIcon />
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {status?.toLowerCase() == "accept" && (
            <span className="status-badge-2 accepted">Accepted</span>
          )}

          {status?.toLowerCase() == "pending" && (
            <span className="status-badge-2 commented">Pending</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogHourCard;
